export class AppConstantes {

    public static FLAG_SIM = 'S';

    public static FLAG_NAO = 'N';

    public static VALOR_MINIMO_PARCELA = 80;

    public static CODIGO_ORIGEM_SITEMA_JURIDICO = 57;
    public static CODIGO_ORIGEM_SITEMA_FIANCA = 67;
    
    public static CODIGO_RETORNO_MARCA_PORTO = 1;
    public static CODIGO_RETORNO_MARCA_ITAU = 2;

   // Projeto Santos Mitsui 2024
    public static TIPOS_MODALIDADES_MITSUI: number[] = [21, 22, 23, 26];
    public static CODIGO_RETORNO_MITSUI = 65;

    // Projeto R3 Azul 2024
    public static CODIGO_RETORNO_MARCA_AZUL = 64;
    public static TIPOS_MODALIDADES_AZUL: number[] = [24, 25];

 }